"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Monetate_module_1 = require("./modules/Monetate.module");
const CookieConsent_module_1 = require("./modules/CookieConsent.module");
const loadMonetateRootModule = () => ({
    hasRouter: false,
    modules: [(0, Monetate_module_1.default)(), (0, CookieConsent_module_1.default)()],
});
exports.default = loadMonetateRootModule;
